import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, token } = useAuth();
  const location = useLocation();

  console.log('🔍 ProtectedRoute: Authentication check', {
    isAuthenticated,
    loading,
    hasToken: !!token,
    pathname: location.pathname
  });

  // If we're still loading OR there's a token present but auth isn't established yet,
  // keep showing the spinner to avoid premature redirects due to timing
  if (loading || (!isAuthenticated && !!token)) {
    console.log('🔄 ProtectedRoute: Still loading, showing spinner');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('❌ ProtectedRoute: Not authenticated, redirecting to login');
    // Redirect to appropriate login page based on the intended route
    if (location.pathname.startsWith('/student/')) {
      return <Navigate to="/login/student" replace />;
    } else if (location.pathname.startsWith('/staff/')) {
      return <Navigate to="/login/staff" replace />;
    } else {
      return <Navigate to="/login/parent" replace />;
    }
  }

  console.log('✅ ProtectedRoute: Authenticated, rendering children');
  return children;
};

export default ProtectedRoute;
